export const environment = {
    production: true,
    firebase: {
    apiKey: "AIzaSyDtvO4fGCmd9Jr5HpcbF_JIETNXJsKDW1Y",
    authDomain: "bwi-1147.firebaseapp.com",
    projectId: "bwi-1147",
    databaseURL: "https://bwi-1147.firebaseio.com",
    storageBucket: "bwi-1147.appspot.com",
    messagingSenderId: "205716311880",
    appId: "1:205716311880:web:d5f26a01f7d4ad73b82d7d",
    measurementId: "G-GY4X9PG32F",
    },
    shopProductsLimit: 50,
    timeToUpdateAgentLocation: 30000,
    deliveryBikeurl: 'assets/img/delivery-bike.png',
    destinationMarkerUrl: 'assets/img/map-marker.png',
    razorpay: {
      description: "Nagda Farms Payment",
      currency: 'INR',
      image: 'https://payment.nagdadairy.in/assets/img/admin-pic.png',
      theme: {
        color: '#01a0e2'
      },
      useCheckoutJs: false
    },
    paytm: {
      CHANNEL_ID: 'WAP',
      WEBSITE: 'DEFAULT',
      INDUSTRY_TYPE_ID: 'Retail',
      ENVIRONMENT: 'production'
    },
    envPaytmActive: false,
    storeName: "Nagda Farms",
    supportPhone: '1234567890',
    scrollLimit:20,
    priceReqFeature:false,
    appSharingImg:'https://payment.nagdadairy.in/assets/img/admin-pic.png',
    deliveryFeature: false,
    ALGOLIA_APP_ID: 'DEYL6OZL2B',
    ALGOLIA_APP_KEY: 'd7f75c2a6d20c84da946c70a08039dbc',
    isDeliveryBasedKm: false,
    orderIdPrefix: 'ORD',
    defaultCountryCode: '+91',
    currencyCode: 'INR',
    taxType: 'GST',
    socialSigin: false,
    defaultProductView: 'list',
    webClientId:'205716311880-hbjpniltckhdve5fv8g803k9q6365a1s.apps.googleusercontent.com',
    productSharing: true,
    phoneLength: 10,
    showFooterLogo: true,
    openAlgoliaSearch:false,
    LOGGLY_API_KEY: 'dd80a702-e3cf-4633-9d38-5ee92fe68193',
    priceForRetail: false,
    referralFeature: false,
    subscriptionFeature: false,
    RFQFeature: false,
    usersScrollLimit: 20,
    limitedTimeDeal: false,
    productRatings: false,
    multiRegion: false,
    multiVendor: false,
    membership: false,
    isDeliveryBasedOnWeight: false,
    userSignature: false,
    freeTrial: false,
    isBwiClient: false,
    lockSystem: false,
    broadcastLimit:24,
    imagesLimit: 5,
    orderUploadedDocImgsLimit: 5,
    resellingFeature: false,
    shareCatalogue: false,
    qtyLeft: 5,
    allOrderStatuses: ['Pending', 'Rejected', 'Confirmed', 'Cancelled', 'Dispatched', 'Delivered', 'Returned'],
    appAccessOnApproval: false,
    pickDrop: false,
    cashfree: {production: false},
    appointmentFeature: false
  };
